module.exports = __webpack_public_path__ + "img/wordry.db997906.png";